import React from "react";
import { Module } from "../Module/Module";

const ModulesTable = ({ modules = [], onRefetch }) => {
  const handleModuleDeleted = (moduleId) => {
    // Recharger les données de la chambre après suppression
    if (onRefetch) {
      onRefetch();
    }
  };

  if (!modules || modules.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Modules installés</h2>
        <div className="text-center py-8 text-gray-500">Aucun module installé dans cette chambre.</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Modules installés ({modules.length})</h2>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">DevEUI</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Version</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {modules.map((module, index) => (
              <Module key={index} data={module} isAssociated={true} onModuleDeleted={handleModuleDeleted} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ModulesTable;
